export default "__VITE_ASSET__Df9l18VC__"